//
// Init Swiper for Aktuelles-Teaser
//

import Swiper, { Navigation} from 'swiper';
Swiper.use([Navigation]);

new Swiper ('.aktuelles-teaser-list', {
  navigation: {
    nextEl: '.swiper-navigation-button-next',
    prevEl: '.swiper-navigation-button-prev',
    disabledClass: 'swiper-navigation-button-disabled',
  },
  observer: true,
  observeParents: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  breakpoints: {
    '992': {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 40,
    },
  },
});

export default {};
